import { consoleEvents } from '@pb/utils'
import { createReducer } from 'redux-act'

import * as actions from './actions'
import initialState from './initialState'

const fetchProvincesStart = (state): any => ({
  ...state,
  isProvincesLoading: true,
})

const fetchProvincesSuccess = (state, provinces): any => ({
  ...state,
  isProvincesLoading: false,
  provinces,
  isProvincesPopulated: true,
  wasProvincesResponseEmpty: provinces.length === 0,
})

const fetchProvincesFail = (state, err): any => {
  consoleEvents.error(`Failed to load provinces`, err)

  return {
    ...state,
    isProvincesLoadingFailed: true,
    isProvincesLoading: false,
  }
}

const postUpgradeToClubStart = (state): any => ({
  ...state,
  isPostUpgradeToClubLoading: true,
  postUpgradeToClubError: null,
})

const postUpgradeToClubSuccess = (state): any => ({
  ...state,
  isPostUpgradeToClubLoading: false,
})

const postUpgradeToClubFail = (state, error): any => ({
  ...state,
  isPostUpgradeToClubLoading: false,
  postUpgradeToClubError: error,
})

const reducer = createReducer((on) => {
  on(actions.fetchProvincesStart, fetchProvincesStart)
  on(actions.fetchProvincesSuccess, fetchProvincesSuccess)
  on(actions.fetchProvincesFail, fetchProvincesFail)
  on(actions.postUpgradeToClubStart, postUpgradeToClubStart)
  on(actions.postUpgradeToClubSuccess, postUpgradeToClubSuccess)
  on(actions.postUpgradeToClubFail, postUpgradeToClubFail)
}, initialState)

export default reducer
